export const uploadToS3 = async (file, signedUrl) => {
  const options = {
    headers: {
      'Content-Disposition': 'attachment',
      'Content-Type': file.type,
    },
  }

  return fetch(signedUrl, {
    method: 'PUT',
    body: file,
    ...options,
  })
}
